<template>
  <div>
    <div id='div1'>
      <div class="print-head">
        <h2 class="print-big-title">
          <img src="../../assets/iqeq.png" style="width: 80px" />福建智趣互联科技股份有限公司</h2>
        <div class="print-sm-title">货物签收单</div>
      </div>
      <div class="w100 print-dv1">
        <div>
          <span>客户编号:{{PageBody.AgentCode}}</span>
          <span>销售下单编号:{{PageHeader.OrderCode}}</span>
          <span>发货通知单编号:{{PageHeader.Code}}</span>
        </div>
      </div>
      <div class="w100 print-dv1">
        <div>
          <span>销售下单时间:{{PageHeader.OrderTime}}</span>
        </div>
      </div>
      <!-- 家长端订单入口用的 -->
      <table class="print-table" v-if="$route.path.indexOf('/Family/SendNotice') > -1">
        <tr>
          <td style="width:50%">客户名称:{{PageBody.CustomerName}}</td>
          <td style="width:50%">供货日期:</td>
        </tr>
        <tr>
          <td>
            <div class="pt10">客户地址:{{PageBody.CustomerAddress}}</div>
          </td>
          <td>
            <div class="pt10">联系人:{{PageBody.CustomerName}}</div>
            <div>联系方式:{{PageBody.CustomerTel}}</div>
          </td>
        </tr>
      </table>
      <!-- 先前发货通知单列表入口 -->
      <table class="print-table" v-else>
        <tr>
          <td style="width:50%">客户名称:{{PageBody.AgentName}}</td>
          <td style="width:50%">供货日期:</td>
        </tr>
        <tr>
          <td>
            <div class="pt10">客户地址:{{PageBody.DefaultAgentAddress}}</div>
          </td>
          <td>
            <div class="pt10">联系人:{{PageBody.ContactName}}</div>
            <div>联系方式:{{PageBody.ContactTel}}</div>
          </td>
        </tr>
      </table>
      <table style="margin-top:-1px;">
        <thead>
          <tr>
            <th style="width: 5%;height: 40px">序号</th>
            <th style="width: 10%">产品编号</th>
            <th style="width:25%;overflow: hidden">产品名称</th>
            <th style="width:25%;">包含单品</th>
            <th style="width: 5%">型号</th>
            <th style="width: 5%">数量</th>
            <th style="width: 6%">备注</th>
            <th style="width: 8%">拼箱箱号</th>
            <th style="width: 10%">拼箱数量</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in PageBody.ListProduct">
            <td>{{index+1}}</td>
            <td>{{item.ProCode}}</td>
            <td>{{item.ProName}}</td>
            <td class="tdTopCss">
              <div class="dpDvCss" v-for="PackDetail in item.PackDetail">{{PackDetail.ProName}} - {{PackDetail.ProNum}}{{PackDetail.ProNaturalUnitName}}</div>
            </td>
            <td>{{item.ProModel}}</td>
            <td>{{item.ProNum}}</td>
            <td>{{item.Remark}}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <table class="print-table" style="margin-top:-1px;">
        <tr>
          <td colspan="2">
            <div class="pt10">
              依据双方合同协议约定，本次下单合计交付货物件数为
              <span class="print-sp-tx"></span>件,
              <span class="print-sp-tx" style="width:200px;"></span>包装方式。
            </div>
            <div class="pt10">物流单号：</div>
            <div class="pt10">寄送方式：{{PageBody.SendModeName}} -- {{PageBody.PayModeName}}
              <span v-show="PageBody.ProjectType==2" style="margin-left:20px;">此单包含已发货样机件数：{{PageBody.OrderProtoTypeDeductibleNum}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="pt10">本单货物收货信息：
              <span class="fwb">收货人姓名</span>
              <span class="print-sp-tx" style="width:200px;">{{PageBody.Consignee}}</span>，
              <span class="fwb">联系方式</span>
              <span class="print-sp-tx" style="width:200px;">{{PageBody.ConsigneeTel}}</span>
            </div>
            <div class="fwb">收货地址:
              <span>{{PageBody.ConsigneeAddress}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="fwb" style="width:50%">验收日期：</td>
          <td style="width:50%">
            <div class="fwb">客户确认签字(验收人):</div>
          </td>
        </tr>
        <tr>
          <td style="width:50%">
            <div class="fwb">验货：
            </div>
            <div>收货方授权收货人员在本单货物签收单据上签字，则即视为收货方对供货方所供货物型号、数量、质量等符合合同或协议约定。
            </div>
          </td>
          <td style="width:50%">
            <div class="fwb">物流公司运输司机签字:</div>
          </td>
        </tr>
        <tr>
          <td style="width:50%">
            <div class="pt10 fwb">供货单位：福建智趣互联科技股份有限公司</div>
            <div class="pt10 fwb">地址：福建省福州市鼓楼区软件大道89号福州软件园G区10号楼 </div>
            <div class="pt10 fwb">邮编：350003&nbsp;&nbsp;&nbsp;&nbsp;电话:0591-87800515</div>
            <!-- <div class="pt10 fwb" v-show="PageBody.OrderRemark!=''">订单备注： {{PageBody.OrderRemark}}</div> -->
          </td>
          <td style="width:50%">
            <div class="fwb">本单货物发货人签字:</div>
          </td>
        </tr>
      </table>

      <div style="padding:10px 0px; ">
        ★货物交接流程：物流公司运输司机拿提货单及货物签收单到发货地点，联系发货人，双方按货物签收单上数量清点无误后签字确认；发货仓库出具货物签收单一式三份，发货仓库留底一份，运输司机持剩余两份货物签收单与货物一起运输到指定收货地址，两份货物签收单由收货人签字确认后，一份由收货方留底，一份由运输司机带走做回执单。★
      </div>

    </div>
    <div>
      <el-row>
        <el-col :span="24" style="display: flex;justify-content: center;margin: 20px 0">
          <el-button @click="printPage" :disabled="isOk">打印</el-button>
          <el-button @click="goListPage">返回列表页</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import NProgress from "nprogress";
import {
  ViewSendGoodsForStock,
  LoadThirdDataForSendPrint,
  SendGoodsPrint,
  LoadDataForSendPrint
} from "@api/sendGoodsApi.js";
import $http from "$http";
import { StockOutPrint } from "@api/stockOutApi.js";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";

module.exports = {
  data() {
    return {
      tabelTitle: "",
      PrintData: {},
      PageHeader: {},
      PageBody: {},
      PageFooter: {},
      time: "",
      isOk: false,
      isFamily: false //家长端订单
    };
  },
  methods: {
    goListPage() {
      if (this.isFamily) {
        //   家长端订单
        window.history.go(-1);
      } else {
        util.redirect(this, "/SendGoods/SendGoodsForHX", false);
      }
    },
    printFn() {
      document.title = "";
      document.body.style.backgroundColor = "white";
      document.body.innerHTML = document.getElementById("div1").innerHTML;
      window.print();
      location.reload();
    },
    printPage() {
      let _session = util.getSessin();
      if (this.$route.query.Goods == undefined) {
        let param = {
          Sid: _session[0],
          Session: _session[1],
          SendId: this.$route.query.Id
        };
        SendGoodsPrint(param).then(res => {
          util.doResult(this, res, () => {
            this.isOk = false;
            this.printFn();
          });
        });
      } else {
        let params = {
          Sid: _session[0],
          Session: _session[1],
          Id: this.$route.query.Id
        };
        StockOutPrint(params).then(res => {
          util.doResult(this, res, () => {
            this.isOk = false;
            this.printFn();
          });
        });
      }
    }
  },
  created: function() {
    let _session = util.getSessin();
    let para = {
      Sid: _session[0],
      Session: _session[1],
      Id: this.$route.query.Id
    };

    let path = this.$route.path;
    if (path.indexOf("/Family/SendNotice") > -1) {
      // 家长端订单打印发货通知单
      this.isFamily = true;
      $http
        .get("api/UserSendGoods/LoadDataForUserSendPrint", para)
        .then(res => {
          let { Data, Cnt } = res.data;
          this.loading = false;
          util.doResult(this, res, () => {
            this.PrintData = res.data.Data;
            this.PageHeader = this.PrintData.PageHeader;
            this.PageBody = this.PrintData.PageBody;
            this.PageFooter = this.PrintData.PageFooter;
            this.tabelTitle = "发货通知单";
          });
        });
    } else {
      this.isFamily = false;
      LoadThirdDataForSendPrint(para).then(res => {
        util.doResult(this, res, () => {
          this.PrintData = res.data.Data;
          this.PageHeader = this.PrintData.PageHeader;
          this.PageBody = this.PrintData.PageBody;
          this.PageFooter = this.PrintData.PageFooter;
          this.tabelTitle = "发货通知单";
        });
      });
    }
  }
};
</script>
<style scoped media="print" lang="scss">
@page {
  size: auto;
  /* auto is the initial value */
  margin-top: 0mm;
  /* this affects the margin in the printer settings */
  margin-bottom: 0mm;
}

.print-head {
  margin-top: 10px;
}

.print-logo {
  height: 50px;
  border-bottom: 1px solid #000;
  padding-top: 30px;
  padding-bottom: 10px;
}

.print-big-title {
  text-align: center;
  position: relative;
  img {
    position: absolute;
    top: -10px;
    left: 10px;
  }
}

.print-sm-title {
  font-weight: normal;
  text-align: center;
  font-size: 18px;
}

table {
  margin: 0 auto;
  width: 100%;
  border-collapse: collapse;
  /*关键d代d码*/
}

th,
td {
  text-align: center;
  border: 1px solid black;
  font-size: 12px;
}

td {
  padding: 3px 0;
}

#div1 {
  margin: 0 100px;
}

#headerContent {
  width: 100%;
  font-size: 8px;
  margin: 20px auto;
}

#headerContent span {
  width: 24.6%;
  display: inline-block;
}

#FootContent {
  width: 100%;
  font-size: 15px;
  margin: 7px auto;
}

#FootContent span {
  width: 24.5%;
  display: inline-block;
}

.print-dv1 > div {
  display: inline-block;
  vertical-align: top;
  text-align: left;
  width: 100%;
  margin-top: 0px;
  padding-bottom: 2px;
  text-indent: 5px;
  line-height: 16px;
  span {
    margin-right: 15px;
  }
}

.txtCss {
  vertical-align: top;
}

.dpDvCss {
  border-bottom: 1px solid #000;
  line-height: 15px;
  font-size: 10px;
}

.txtCss .dpDvCss:last-child {
  border: 0px !important;
}

.print-table {
  td {
    text-align: left;
    padding: 3px 5px;
    vertical-align: top;
  }
  .print-sp-tx {
    display: inline-block;
    min-width: 100px;
    vertical-align: top;
    border-bottom: 1px solid #000;
    height: 18px;
  }
  .pt10 {
    padding-bottom: 2px;
  }
  .fwb {
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// SendGoodsForHXPage.vue?2d1f8975